import markdownIt from 'markdown-it';
import { markdownItFancyListPlugin } from 'markdown-it-fancy-lists';
import updateTableColumnsWidth from '@/lib/tableUtils';

const md = markdownIt({ html: true });

md.use(markdownItFancyListPlugin);

const renderVariable = () => {
  // TODO: move render variable code from store.js here
};

const renderContextValue = (contextItem, userRole, isAdminDraftView, notEditable = false) => {
  const itemKey = contextItem.key.toLowerCase();

  let itemValue;

  // Convert to HTML
  let html = md.render(contextItem.value);
  if (html) html = html.trim();

  // Fix for table column resizing.
  if (html.includes('</th>') || html.includes('</td>')) {
    html = updateTableColumnsWidth(html);
  }

  // context value only contain a single paragraph - treat it as inline value
  // remove <p></p>

  let headerTag = null;
  const originalHtml = html;

  if (html && (html.includes('</p>') || html.match(/<h[1-6]>/))) {
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(html, 'text/html');
    let pElements = null;

    if (html.includes('</p>')) {
      pElements = parsedHtml.getElementsByTagName('p');
    } else {
      headerTag = html.match(/<h[1-6]>/)['0'];
      headerTag = headerTag.substring(headerTag.indexOf('<') + 1, headerTag.indexOf('>'));
      pElements = parsedHtml.getElementsByTagName(headerTag);
    }

    if (
      parsedHtml.body.children &&
      parsedHtml.body.children.length === 1 &&
      pElements.length === 1
    ) {
      html = pElements[0].innerHTML;
    }
  }

  if (!isAdminDraftView && [2, 3, 4].includes(userRole)) {
    if (!notEditable) {
      if (headerTag) {
        itemValue = `<${headerTag}><span class="validContext ce-cursor" style="display:inline;" data-key="${itemKey}">${html}</span></${headerTag}>`;
      } else {
        itemValue =
          '<span class="validContext ce-cursor" style="display:inline;"' +
          ` data-key="${itemKey}">${html}</span>`;
      }
    } else if (headerTag) {
      itemValue = `<${headerTag}><span class="tooltip validContext">${html}<span class="tooltip-text">This value can't be edited.</span></span></${headerTag}>`;
    } else {
      itemValue = `<span class="tooltip validContext">${html}<span class="tooltip-text">This value can't be edited.</span></span>`;
    }
  } else if (headerTag) {
    itemValue = originalHtml;
  } else {
    itemValue = html;
  }

  return itemValue;
};

export { renderVariable, renderContextValue };
